import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Tooltip, Typography } from "@mui/material";

type Props = {
  /** Shown in the tooltip (can include <code> via Typography component="span" / plain text). */
  children: React.ReactNode;
  /** Accessible label for the icon button */
  ariaLabel?: string;
};

/**
 * Keeps long Entra / API permission explanations out of the main layout.
 */
const AdminRoleInfoTooltip: React.FC<Props> = ({
  children,
  ariaLabel = "Permission details",
}) => (
  <Tooltip
    title={
      <Typography variant="body2" component="div" sx={{ maxWidth: 380 }}>
        {children}
      </Typography>
    }
    placement="right-start"
    arrow
    enterTouchDelay={0}
    slotProps={{
      tooltip: {
        sx: {
          maxWidth: 420,
          bgcolor: "grey.900",
          "& .MuiTooltip-arrow": { color: "grey.900" },
        },
      },
    }}
  >
    <IconButton size="small" aria-label={ariaLabel} sx={{ ml: 0.5, verticalAlign: "middle" }}>
      <InfoOutlinedIcon fontSize="small" color="action" />
    </IconButton>
  </Tooltip>
);

export default AdminRoleInfoTooltip;
